import { Link } from "react-router-dom";
import { Seo } from "../components/site/Seo";

export default function NotFound() {
  return (
    <div className="container-news flex min-h-[50vh] flex-col items-start justify-center py-20" data-testid="not-found-page">
      <Seo title="Stranica nije pronađena" noindex />
      <p className="kicker">Greška 404</p>
      <h1 className="mt-3 font-display text-4xl font-semibold text-ink sm:text-5xl">Ova stranica ne postoji</h1>
      <p className="mt-4 max-w-md text-muted-foreground">Možda je tekst premješten, ili link nije ispravan.</p>
      <Link to="/" className="mt-8 rounded-sm bg-navy px-5 py-3 text-sm font-semibold text-white dark:bg-pulse" data-testid="not-found-home-link">Na naslovnu</Link>
    </div>
  );
}
